import { ExternalLinkIcon } from 'lucide-react';
import { forwardRef, type HTMLAttributeAnchorTarget, type HTMLAttributes } from 'react';
import { Link } from 'react-router';
import RightArrow from '~/assets/right-arrow';

interface Props {
  to: string;
  title: string;
  subtitle: string;
  target?: HTMLAttributeAnchorTarget;
  rel?: string;
}

const ContentLink = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement> & Props>(
  ({ className, to, title, subtitle, target, rel, ...props }, ref) => {
    return (
      <div ref={ref} className={className} {...props}>
        <Link to={to} target={target} rel={rel}>
          <div className="py-4">
            <div className="flex items-center">
              <p className="text-base text-primary">{title}</p>
              {target === '_blank' ? (
                <ExternalLinkIcon className="h-3 w-3 ml-2 stroke-primary" />
              ) : (
                <RightArrow className="h-3 w-3 ml-2 stroke-primary" />
              )}
            </div>
            <p className="text-xs">{subtitle}</p>
          </div>
        </Link>
        <hr className="h-[2px] bg-background border-0" />
      </div>
    );
  }
);

ContentLink.displayName = 'ContentLink';
export default ContentLink;
